export default __webpack_public_path__ + "static/media/image-header-2.5454f955.png";